export interface OptionsChangeInfo {
  resolutionChanged: boolean;
  rotationChanged: boolean;
}

import { mergeWithDefaults } from "../option.ts";

export class OptionsManager {
  private previousOptions: Record<string, unknown>;
  private callback: ((info: OptionsChangeInfo) => void) | undefined;
  private listener: ((e: Event) => void) | undefined;

  constructor() {
    this.previousOptions = {
      ...mergeWithDefaults(globalThis.options),
    } as Record<string, unknown>;
  }

  onChange(cb: (info: OptionsChangeInfo) => void): void {
    this.callback = cb;
  }

  startListening(): void {
    this.listener = (_: Event) => {
      const currentOptions = {
        ...mergeWithDefaults(globalThis.options),
      } as Record<string, unknown>;

      const resolutionChanged = this.previousOptions.resolution !==
        currentOptions.resolution;
      const rotationChanged = this.previousOptions.cameraRotation !==
        currentOptions.cameraRotation;

      // Log option diffs
      const changedKeys: string[] = [];
      const allKeys = new Set([
        ...Object.keys(this.previousOptions),
        ...Object.keys(currentOptions),
      ]);
      for (const key of allKeys) {
        if (this.previousOptions[key] !== currentOptions[key]) {
          changedKeys.push(key);
        }
      }
      if (changedKeys.length > 0) {
        const diff: Record<string, { from: unknown; to: unknown }> = {};
        for (const key of changedKeys) {
          diff[key] = {
            from: this.previousOptions[key],
            to: currentOptions[key],
          };
        }
        console.log("[options-changed] diff:", diff);
      } else {
        console.log("[options-changed] no actual value changes detected");
      }

      this.previousOptions = currentOptions;

      this.callback?.({ resolutionChanged, rotationChanged });
    };
    globalThis.addEventListener("options-changed", this.listener);
  }

  stopListening(): void {
    if (this.listener) {
      globalThis.removeEventListener("options-changed", this.listener);
      this.listener = undefined;
    }
  }

  dispose(): void {
    this.stopListening();
    this.callback = undefined;
  }
}
